import React from 'react';
import styled from 'styled-components';

import closeIcon from '../../asset/img/common/modal_close_icon.svg';

const HeaderStyled = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 16px;
  height: 64px;
  background-color: #fff;
  border-bottom: 1px solid var(--GrayScale-400);
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100vw;
  left: 0;
  gap: 16px;
  .title {
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
  }
`;

//오른쪽에서 왼쪽으로오는 X표시있는 헤더
const ModalHeader = ({ title, onClose }) => {
  return (
    <HeaderStyled>
      <img src={closeIcon} alt="close" onClick={onClose} />

      <div className="title">{title}</div>
    </HeaderStyled>
  );
};

export default ModalHeader;
